module.exports = __webpack_public_path__ + "img/SCHOOLAP.9606284f.png";